var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28571 3.92857H6.07143V0.714286C6.07143 0.319866 5.75156 0 5.35714 0H4.64286C4.24844 0 3.92857 0.319866 3.92857 0.714286V3.92857H0.714286C0.319866 3.92857 0 4.24844 0 4.64286V5.35714C0 5.75156 0.319866 6.07143 0.714286 6.07143H3.92857V9.28571C3.92857 9.68013 4.24844 10 4.64286 10H5.35714C5.75156 10 6.07143 9.68013 6.07143 9.28571V6.07143H9.28571C9.68013 6.07143 10 5.75156 10 5.35714V4.64286C10 4.24844 9.68013 3.92857 9.28571 3.92857Z",
    fill: "#E2FFEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.120a2773cde73afc2daf281d21de6e58.svg";
export { ForwardRef as ReactComponent };